const NAVBARLIST = {
    Home: '/',    
    Advisory: 'advisory',
    Team: 'team', 
    // Partners: 'partners',
    News: 'news',
    Gallery: 'gallery',
    // Contact: 'contact',
    //Documents: 'documents',
};

export default NAVBARLIST;